/* eslint-disable react-hooks/exhaustive-deps */
import { Typography } from 'antd';
import { reportApis } from 'Api/reports';
import { PermissionContext } from 'components/Global/AuthLayout';
import Buttons from 'components/Global/Buttons';
import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useContext, useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import GlobalReportTable from '../GlobalReportTable';
import GenerateNapsaModal from './GenerateNapsaModal';
import Styles from './index.module.scss';

const NapsaReportComponent = () => {
	const [totalRecords, setTotalRecords] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState('');
	const [modalOpen, setModalOpen] = useState(false);
	const [napsaReportData, setNapsaReportData] = useState<any[]>([]);
	const context = useContext(PermissionContext);
	const check = context.allowedPermissions.includes('Add_Payroll_Reports');

	const { Text } = Typography;

	const buttons = [
		{
			text: 'Generate',
			isLoading: false,
			className: 'btn-blue',
			// icon: <AddSvg />,
			isSubmit: true,
			onclick: () => {
				setModalOpen(true);
			},
			disabled: isLoading,
		},
	];

	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
		let order = '';
		if (sorter?.order === 'ascend') {
			order = 'asc';
		} else if (sorter?.order) {
			order = 'desc';
		}
		setSortOrder(order);
		setSortField(sorter.field);
	};

	const cancelModal = () => {
		setModalOpen(false);
	};

	const fetchNapsaReports = async () => {
		try {
			const query = {
				page: currentPage,
				sortBy: sortField,
				sortOrder: sortOrder,
				pageSize: pageSize,
			};
			setIsLoading(true);
			const napsaReportData = await reportApis.getNapsaReports(query);
			setNapsaReportData(napsaReportData.data.data);
			setTotalRecords(napsaReportData.data.total);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching NAPSA Reports';
			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchNapsaReports();
	}, [currentPage, sortField, sortOrder, pageSize]);

	return (
		<>
			<div className={Styles['container']}>
				<div className={Styles['napsa-header']}>
					<Text style={{ marginRight: '15px', color: '#444' }}>
						National Pension Scheme Authority (NAPSA) Report. This
						report provides details on contributions made by
						employees and employers to the national pension fund for
						retirement benefits.
					</Text>
					{check && <Buttons buttons={buttons} />}
				</div>

				<GlobalReportTable
					ReportData={napsaReportData}
					isLoading={isLoading}
					tableChangeHandler={tableChangeHandler}
					totalRecords={totalRecords}
					pageSize={pageSize}
					currentPage={currentPage}
				/>
			</div>
			{modalOpen && (
				<GenerateNapsaModal
					open={modalOpen}
					cancelGenerateModal={cancelModal}
					fetchNapsaReportDetails={fetchNapsaReports}
				/>
			)}
		</>
	);
};

export default NapsaReportComponent;
